import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { FactoryPathUrl, ExecutiveDashboardUrl } from "../../../utils/common";
import { EXECUTIVE_DASHBOARD } from "@/utils/constants";

export const usePermissionGuard = (
    selectedCustomerName: string,
    customerSitesLoading: boolean,
    permittedCustomersLoading: boolean,
    MaintenancePath: boolean,
    FactoryPath: boolean,
    ExecutivePath: boolean,
    permittedCustomers: any[],
    customer: string,
    userInfo: any
) => {
    const navigate = useNavigate();

    useEffect(() => {
        const lowerPath = window.location.pathname.toLowerCase();
        if (selectedCustomerName && !customerSitesLoading && !permittedCustomersLoading) {
            // Check maintenance access
            if (lowerPath.includes("maintenance") && !MaintenancePath) {
                navigate("/403");
            }
            // Check factory dashboard access (but exclude ExecutiveDashboard)
            if (lowerPath.includes("view/factorydashboard") && !FactoryPath) {
                navigate("/403");
            }
            if (lowerPath.includes(`/view/${EXECUTIVE_DASHBOARD}`) && !ExecutivePath) {
                navigate("/403");
            }
        }
    }, [FactoryPath, MaintenancePath, selectedCustomerName, customerSitesLoading, permittedCustomersLoading, navigate]);

    useEffect(() => {
        if (!permittedCustomersLoading && !isEmpty(permittedCustomers) && !isEmpty(customer) && !FactoryPathUrl(FactoryPath) && !ExecutiveDashboardUrl(ExecutivePath)) {
            const permittedCustomerExists = permittedCustomers.find((data) => data.customer === customer);
            if (isEmpty(permittedCustomerExists) && !isEmpty(customer)) {
                window.location.href = `/`;
            }
        }
    }, [permittedCustomersLoading, permittedCustomers, customer, FactoryPath, userInfo]);
};